import React, { Fragment, useState, useEffect } from "react";
import { database, auth } from "../../database/firebase";
import { useHistory } from "react-router-dom";
import { Header } from "../../components";
import validator from 'validator';


function RegisterUser() {
  const history = useHistory();
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [newUser, setNewUser] = useState(
    {
      username: "",
      email: "",
      password: "",
      role: "",
    }
  );

  const [urole, setURole] = useState({});

  useEffect(() => {
    const fetchUser = async () => {
      let uid = localStorage.getItem("uid");
      if (uid) {
        let userUid = JSON.parse(uid);
        database.child(`users/${userUid}/role`).once("value", (snap) => {
          let data = snap.val();
          setURole(data);
        });
      };
    }

    fetchUser();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewUser((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }

  const handleEmail = (e) => {

    const { name, value } = e.target;

    if (validator.isEmail(value)) {
      setEmailError('Valid Email!')
      setNewUser((prevState) => ({
        ...prevState,
        [name]: value
      }));
    } else {
      setEmailError('Enter valid Email!')
    }
    // }));
  }

  const handlePassword = (e) => {

    const { name, value } = e.target;

    if (value.length > 8) {
      setPasswordError('Valid Password!');
      setNewUser((prevState) => ({
        ...prevState,
        [name]: value
      }));

    } else {
      setPasswordError('Enter at least 8 characters.')
    }

  }

  const {
    username,
    email,
    password,
    role,
  } = newUser;

  const handleSubmit = () => {
    if (!email || !password || !role || !username) {
      alert("All fields are required.");
    } else {
      auth
        .createUserWithEmailAndPassword(email, password)
        .then((firebaseUser) => {
          let newUser = {
            username,
            email,
            role,
            uid: firebaseUser.user.uid,
            password: password
          };

          database
            .child(`users/${firebaseUser.user.uid}`)
            .set(newUser)
            .then(() => {
              if (role === "master") {
                database
                  .child(`accounts/masterUser/${firebaseUser.user.uid}`)
                  .set(newUser)
              }
              if (role === "superadmin") {
                database
                  .child(`accounts/superAdmin/${firebaseUser.user.uid}`)
                  .set(newUser)
              }

              alert("User signed up successfully.");
              history.push("/registeruser");
            });
        })
        .catch((err) => {
          alert(err.message);
        });
    }
  };


  return (
    <div className="md:flex">
      <aside class="md:h-screen md:sticky md:top-0">
        <Header />
      </aside>
      <Fragment>
        <div className="min-h-screen w-full bg-gray-100 py-6 flex flex-col items-center justify-center sm:py-12 z-0">
          <div className="max-w-screen-lg mx-auto px-5 py-10 rounded-3xl bg-white shadow-lg sm:p-10">
            <div className="text-left space-y-2 sm:text-left">
              <div className="space-y-0.5">
                <p className="text-lg text-blue-900 font-sans font-bold">
                  Register Users
                </p>
              </div>

            </div>
            <div>
              <p> Email Address</p>
              <input
                type="email"
                placeholder="Email Address"
                name="email"
                id="email"
                onChange={handleEmail}
                className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              />

              <span className="text-blue-500"> {emailError} </span>
              <p>Username</p>
              <input
                type="text"
                placeholder="Username"
                name="username"
                id="username"
                onChange={handleChange}
                className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              />
              <p>Role</p>
              <select id="role" name="role" onChange={handleChange}
                className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 mb-4 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-offset-gray-100 focus:ring-indigo-500"
              >
                <option value="view" className="text-sm font-medium text-gray-700"> User (L1 View) </option>
                <option value="superview" className="text-sm font-medium text-gray-700"> User (L2 View)</option>
                <option value="admin" className="text-sm font-medium text-gray-700"> Admin (L1 Editor) </option>
                <option value="superadmin" className="text-sm font-medium text-gray-700"> Admin (L2 Editor) </option>
                {urole === "master" ?
                  <option value="master" className="text-sm font-medium text-gray-700"> Master User </option>
                  : null}
              </select>


              <p> Password</p>
              <div className="flex justify-between items-center">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                  name="password"
                  id="password"
                  onChange={handlePassword}
                  className="my-3 flex-1  appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                />
                <div
                  onClick={() => setShowPassword(!showPassword)}
                  className=" hover:text-blue-800 rounded px-2 py-1 text-sm text-gray-600 font-mono cursor-pointer"
                  htmlFor="toggle">

                  {showPassword ?
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    </svg>
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>}
                </div>
              </div>

              <span className="text-blue-500"> {passwordError} </span>
              <div className="text-center">
                <button
                  onClick={handleSubmit}
                  type="submit"
                  className="my-4 w-full bg-blue-600 text-white text-base font-regular py-2 px-4 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200">
                  Register</button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </div>
  );

}
export default RegisterUser;
